import { getAccessToken } from '@ui/auth';
import { useGetCurrentUser } from 'ze-sdk';
export function useCurrentUser() {
    const token = getAccessToken();
    const { isLoading, data, error } = useGetCurrentUser({
        query: {
            enabled: !!token
        }
    });
    return {
        user: data === null || data === void 0 ? void 0 : data.value,
        isLoading,
        error
    };
}
